<template>
  <div id="grid-calidad">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card-actions class="pb-3">
            <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text"
                >Consulta de informes</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                v-if="btnHidden != true"
                @click="newCalidad()"
                >Agregar Reporte Calidad</v-btn
              >
            </v-toolbar>
          </v-card-actions>
          <v-layout class="d-flex pa-2">
            <div class="d-flex pa-2" xs12 sm6>
              <v-text-field
                width="300px"
                v-model="txtBusqueda"
                placeholder="Ingresa el nombre o código para la busqueda por palabra clave"
                single-line
              ></v-text-field>
              <v-btn
                color="primary"
                @click="loadDataCalidad()"
                :disabled="txtBusqueda.length < 3"
                class="shrink"
                ><v-icon dark left>search</v-icon>Buscar</v-btn
              >
              <v-btn
                color="secondary"
                @click="limpiaBuscador()"
                :disabled="txtBusqueda.length < 3"
                class="shrink"
                ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
              >
            </div>
          </v-layout>
          <v-data-table
            :headers="headers"
            :items="itemsCalidad"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.author }}</td>
              <td class="text-xs-left">{{ props.item.nivel.descripcion }}</td>
              <td class="text-xs-left">
                {{ props.item.tipoMaterial.descripcion }}
              </td>
              <td class="text-xs-left">
                {{ props.item.tipoPrueba.descripcion }}
              </td>
              <td class="text-xs-left">
                {{ props.item.tipoControlCalidad.descripcion }}
              </td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Descargar Documento"
                  @click="downloadFile(props.item.id, props.item.filename)"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA USUARIO -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>

            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="primary"
              small
            >
              <v-icon>cloud_download</v-icon> </v-btn
            >&nbsp;Descargar Documento
          </v-card-actions>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
export default {
  name: "grid-calidad",
  components: {
    LoadingDescarga,
    Loading,
  },
  props: {
    itemsDocumento: {},
  },

  data() {
    return {
      txtBusqueda: "",
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      dialogLoading: false,
      loading: false,
      dialog: false,
      btnHidden: false,
      usuarioLoggedTipe: "",
      contratoId: "",
      itemsCalidad: [],
      headers: [
        { text: "Autor", align: "left", sortable: false, value: "author" },
        { text: "Nivel", sortable: false, value: "nivel" },
        { text: "Tipo Material", sortable: false, value: "tipoMaterial" },
        { text: "Tipo Prueba", sortable: false, value: "tipoPrueba" },
        {
          text: "Tipo de Control de Calidad",
          sortable: false,
          value: "tipoControlCalidad",
        },
        { text: "Accion", sortable: false, value: "" },
      ],
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    if (this.usuarioLoggedTipe == "AGENCIA") {
      this.btnHidden = true;
    } else {
      this.btnHidden = false;
    }
  },

  mounted() {
    this.idUsuario = this.$store.getters.userLogged.id;
    this.loadDataCalidad();
  },
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    async loadDataCalidad() {
      this.loading = true;
      this.itemsCalidad = await this.loadQualityByContract();
      this.miPaginacion.totalItems = this.itemsCalidad.length;
      if (this.itemsCalidad.length > 0) {
        this.$parent.$parent.alerta = false;
      } else {
        this.$parent.$parent.alerta = true;
      }
      this.loading = false;
    },

    async loadQualityByContract() {
      this.body = {
        subProceso: this.$store.getters.subProTabSelectedStored,
        idContrato: this.contratoId,
        txtBusqueda: this.txtBusqueda,
      };
      return await axios
        .post("/reportes_calidad/filtro", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    limpiaBuscador() {
      this.txtBusqueda = "";
      this.loadDataCalidad();
    },

    downloadFile(id, filename) {
      this.dialogLoading = true;
      axios({
        url:
          "reporte_calidad/" +
          id +
          "/download/" +
          this.idUsuario +
          "/" +
          this.contratoId,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    newCalidad() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "CalidadRegistraMecanizado",
          params: { tipeView: "crear" },
        });
      }, 1000);
    },
  },
};
</script>
